export default __webpack_public_path__ + "static/GoodHeadlinePro-Bold-943317796f72790eff13a2c49ddf9374.woff2";